import { useTranslation } from 'react-i18next';

import type { Block, Section } from '@/api/courses';

/**
 * «Урок закроется, когда вы заполните: …» (26.09.2026, вариант В разбора
 * `docs/CHECK-2026-09-26-KHABIBULLA-ANSWERS.md`).
 *
 * Ученик ответил на всё в разделе, кроме сочинения или записи, и не знал, что урок держит именно
 * оно: урок не закрывался, следующий не открывался. Какие разделы застряли — решает
 * `stuckOnOpenTasks` (`lib/sectionCompletion.ts`); здесь только показ и переход к разделу.
 */
export function OpenTasksHoldNotice({
  items,
  onSelect,
}: {
  items: { section: Section; blocks: Block[] }[];
  onSelect: (sectionId: string) => void;
}) {
  const { t } = useTranslation();
  if (items.length === 0) return null;
  const taskName = (b: Block) =>
    t(
      b.type === 'essay'
        ? 'lessonPlayer.holdTaskEssay'
        : b.type === 'open_items'
          ? 'lessonPlayer.holdTaskItems'
          : 'lessonPlayer.holdTaskVoice',
    );
  return (
    <div data-open-tasks-hold className="mb-3 rounded-[16px] bg-warning-container px-4 py-2.5 text-[12.5px] text-on-warning-container">
      <p className="font-semibold">{t('lessonPlayer.holdTitle')}</p>
      <ul className="mt-1 space-y-1">
        {items.map(({ section, blocks }) => (
          <li key={section.id}>
            <button type="button" onClick={() => onSelect(section.id)} className="text-left underline">
              {t('lessonPlayer.holdItem', {
                section: section.title,
                tasks: Array.from(new Set(blocks.map(taskName))).join(', '),
              })}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
